import { constants } from "@qgiv/core-js";

const getCategoryInitialTouched = (settings) => {
    const ret = {};
    const { categories } = settings;
    const autoSelectOnlyCategory = categories.length === 1;
    const Category = autoSelectOnlyCategory ? [`${categories[0].id}`] : [];
    if (Category && Category.length > 0) {
        ret.Category = true;
    }
    return ret;
};

const getRegistrationRoleInitialTouched = (settings) => {
    const ret = {};
    const {
        ENUMS: {
            EntityType: { REGISTRATION },
        },
    } = constants;
    const { teams = [] } = settings;
    const autoSelectIndividual = teams && teams.length === 0;
    const Registration_Role = autoSelectIndividual ? [`${REGISTRATION}`] : [];
    if (Registration_Role && Registration_Role.length > 0) {
        ret.Registration_Role = true;
    }
    return ret;
};

export const getInitialTouched = (settings, savedRegistrationValues = {}) => {
    const touched = {
        ...getCategoryInitialTouched(settings),
        ...getRegistrationRoleInitialTouched(settings),
    };
    if (Object.keys(savedRegistrationValues).length > 0) {
        const savedTouched = Object.keys(savedRegistrationValues).reduce(
            (_touched, key) => {
                return {
                    ..._touched,
                    [key]: true,
                };
            },
            {},
        );
        return {
            ...touched,
            ...savedTouched,
        };
    }
    return touched;
};
